{
  "account": {
    "title": "내 계정",
    "list": {
      "title": "계정",
      "description": "연결된 계정의 인보이스 목록"
    },
    "form": {
      "name": {
        "title": "이름",
        "description": "귀하의 계정 이름"
      },
      "password": {
        "title": "비밀번호",
        "description": "계정의 새 비밀번호를 설정하세요. 현재 비밀번호를 유지하려면 비워두세요"
      },
      "emailPreferences": {
        "title": "이메일 환경설정",
        "description": "이메일 알림 유형 선택"
      }
    },
    "billing": "결제 정보",
    "subscriptions": "구독",
    "manageSubscription": "구독 관리",
    "popup": {
      "cancel": "구독을 취소하시겠습니까?<br/>웹사이트는 현재 구독 기간이 끝날 때까지 번역이 계속됩니다. 이후 번역이 비활성화됩니다.<br/>사용하지 않은 기간에 대한 환불은 불가능합니다.",
      "downgrade": "다운그레이드하시겠습니까? 다운그레이드는 즉시 적용됩니다.<br/>현재 결제 주기의 남은 기간에 대한 환불은 불가능합니다.<br/>새 플랜 가격은 다음 결제 주기에 적용됩니다.",
      "default": "플랜을 변경하시겠습니까?",
      "resume": "구독을 재개하시겠습니까?"
    }
  },
  "ai_translation": {
    "header": "AI 번역",
    "plan": {
      "header": "AI 번역 요금제",
      "used": "AI 크레딧에서 {words_used}/{words_allowed}단어를 사용했습니다.",
      "remaining": "사용 가능한 AI 크레딧:",
      "words": "단어",
      "add_more_credits": "AI 크레딧 추가",
      "details": {
        "idiomatic_expressions": "관용구 및 전문 용어",
        "background_translation": "백그라운드 번역",
        "best_website": "완벽한 번역 품질이 필요한 웹사이트",
        "page_context": "번역을 위한 페이지 및 웹사이트 컨텍스트",
        "perfect_quality": "완벽한 품질, 저렴한 가격",
        "no_recurring": "정기 결제 없음, 선불제",
        "save_40": "$20 요금제 대비 40% 절약",
        "save_50": "$20 요금제 대비 50% 절약"
      },
      "quota": "{estimated_words}단어 ~ {estimated_pages}페이지"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI 번역",
        "intro": "Linguise는 번역 작업에 최적화된 최신 Llama AI LLM 모델을 활용한 프리미엄 기능인 Linguise AI 번역을 공개합니다. 페이지와 전체 웹사이트 컨텍스트를 모두 고려해 완벽한 정확도를 제공합니다. 모든 언어로 완벽하게 전달되도록 최고의 번역 품질을 제공하세요.",
        "button": "지금 업그레이드"
      },
      "alert": {
        "description": "이 기능은 현재 요금제에 포함되어 있지 않으며 별도 구매가 필요합니다.\n아래 모든 옵션을 사용하려면 이 애드온을 활성화하세요."
      },
      "languages": {
        "title": "AI 번역 적용 언어",
        "description": "AI 번역을 적용할 특정 언어 선택"
      },
      "button": {
        "save": "설정 저장"
      },
      "form": {
        "advanced": {
          "title": "고급 AI 지시사항",
          "description": "고급 AI 지시사항"
        },
        "enable_mode": {
          "title": "AI 번역 활성화",
          "description": "AI 번역을 활성화할 방식을 선택하세요.\n규칙만은 다음 규칙을 적용합니다.\n라이브 에디터만은 라이브 에디터 보기에서 페이지별로 번역을 활성화합니다.\n규칙 및 라이브 에디터는 두 기능을 모두 사용합니다.",
          "disabled": "비활성화",
          "rules": "규칙만",
          "live_editor": "라이브 에디터만",
          "all": "규칙 및 라이브 에디터"
        },
        "rule_application": {
          "description": "정적 콘텐츠 또는 동적 콘텐츠 또는 둘 다에 AI 번역 적용",
          "title": "콘텐츠에 적용",
          "all": "모든 콘텐츠",
          "static": "정적 콘텐츠",
          "dynamic": "동적 콘텐츠"
        },
        "website_topic": {
          "title": "웹사이트 주제",
          "placeholder": "스시 레스토랑...",
          "description": "더 나은 번역 품질을 위해 웹사이트 주제를 정의하세요(예: 법률, 스시 레스토랑, 자전거 부품 전자상점…)\n영어로 주제를 입력하세요."
        },
        "apply_to_urls": {
          "title": "URL에 적용",
          "description": "AI 번역을 적용할 특정 URL 선택",
          "all_urls": "모든 URL",
          "selected_urls": "선택한 URL",
          "label": "적용할 URL",
          "placeholder": "적용할 URL",
          "wildcard": "와일드카드",
          "regex": "정규 표현식",
          "add": "새로 추가",
          "expression": "표현 유형"
        },
        "apply_languages": {
          "title": "언어에 적용",
          "description": "AI 번역을 적용할 특정 언어 선택",
          "all_languages": "모든 언어",
          "selected_languages": "선택한 언어",
          "placeholder": "언어 선택...",
          "feedback": "언어를 선택해야 합니다"
        },
        "formality": {
          "title": "격식",
          "description": "번역에서 격식 정도를 지정할 수 있습니다. 독자나 상황에 따라 중요할 수 있습니다.\n\"중립\"은 원문의 격식을 유지하려고 합니다.\n\"격식체\"는 전문적이거나 비즈니스, 법률 콘텐츠에 적합합니다(예: 스페인어의 \"usted\" 사용).\n\"비격식체\"는 캐주얼하거나 대화형 콘텐츠에 적합합니다(예: 스페인어의 \"tú\" 사용).",
          "neutral": "중립",
          "formal": "격식체",
          "informal": "비격식체"
        },
        "sentence_structure": {
          "classic": "전통적",
          "short": "짧고 강렬한 문장",
          "detailed": "자세히 설명하는 문장",
          "title": "문장 구조",
          "description": "글쓰기 스타일 선호도를 정의합니다."
        },
        "content_purpose": {
          "marketing": "마케팅/홍보(설득적이고 매력적인 톤)",
          "technical": "기술/교육(명확하고 정확하며 행동 지향적)",
          "support": "고객 지원(공감적이고 도움이 되며 안심시키는)",
          "legal": "법률/규정(정확하고 격식 있으며 모호하지 않은)",
          "educational": "교육(명확하고 구조적이며 접근 가능한)",
          "other": "기타(영어로)",
          "title": "콘텐츠 목적",
          "description": "번역되는 콘텐츠의 기능적 목적을 정의합니다.",
          "other_placeholder": "목적 설명..."
        },
        "target_audience": {
          "title": "대상 독자",
          "description": "번역된 콘텐츠의 예상 독자를 지정합니다(영어로 입력).",
          "placeholder": "예: 스페인어를 사용하는 부모, EU 개인정보보호 담당자"
        },
        "override_default_translations": {
          "title": "기본 번역 덮어쓰기",
          "description": "예로 설정하면, 이미 클라우드 AI 번역(기본 번역 모델)으로 번역된 콘텐츠도 AI(Linguise AI)로 강제 번역합니다."
        },
        "force_replace_before": {
          "title": "AI 재번역 강제",
          "description": "선택한 날짜 이전에 AI로 번역된 모든 콘텐츠를 AI로 다시 번역합니다. 예를 들어 이전 모델로 번역된 콘텐츠가 해당됩니다. 규칙이 적용되는 페이지를 다음에 방문할 때 다시 번역되며 AI 크레딧을 사용합니다.",
          "before_date": "날짜 이전"
        },
        "model": {
          "current": "현재",
          "title": "모델",
          "description": "사용할 LLM 번역 모델을 선택하세요",
          "load_error": "사용 가능한 모델을 불러올 수 없습니다. 나중에 다시 시도해 주세요.",
          "thinking_warning": "이 모델은 높은 수준의 추론(\"사고\")을 사용하며 번역당 훨씬 더 많은 토큰을 소비합니다."
        },
        "override_manual_and_selected": {
          "no_default": "아니오 (기본값)",
          "title": "수동 번역 및 선택한 번역 덮어쓰기",
          "description": "기본적으로 직접 수정한 번역은 AI 강화 번역이 생성된 후에도 항상 웹사이트에 유지됩니다. 대신 AI 강화 번역을 표시하려면 예로 설정하세요. 수동 번역은 그대로 보관되며 언제든지 다시 전환할 수 있습니다. 이는 새 번역을 얻기 위해 페이지를 다시 번역할 때도 적용되며, 이 경우 최신 번역이 자동으로 사용됩니다."
        }
      },
      "message": {
        "save_success": "현재 이미 번역된 콘텐츠 중 AI 번역으로 향상될 페이지 수는 약 {{ai_affected_urls}}개입니다.",
        "save_success_only": "설정이 성공적으로 저장되었습니다."
      }
    },
    "pricing": {
      "plan": {
        "title": "AI 번역 할당량 주문",
        "buy_button": "AI 번역 패키지 구매"
      },
      "modal": {
        "title": "플랜 변경 확인",
        "description": "AI 번역 플랜을 변경하시겠습니까?",
        "button_cancel": "취소",
        "button_confirm": "확인",
        "loading": "잠시만 기다려 주세요...",
        "amount": "금액",
        "credit": "크레딧",
        "total_due": "총 결제 금액"
      },
      "comparison": {
        "title": "Google Cloud AI 번역\nvs Linguise AI 번역",
        "list": {
          "0": {
            "google": "빠르고 안정적인 번역",
            "linguise": "관용구 및 기술 표현 처리"
          },
          "1": {
            "google": "웹사이트 모든 페이지 즉시 번역",
            "linguise": "백그라운드에서 번역 생성"
          },
          "2": {
            "google": "최고 품질, 저렴한 가격",
            "linguise": "완벽한 품질, 저렴한 가격"
          },
          "3": {
            "google": "대규모 웹사이트나 예산 적은 경우 최적",
            "linguise": "번역 품질이 완벽해야 하는 웹사이트에 최적"
          },
          "4": {
            "google": "번역을 위한 페이지 컨텍스트",
            "linguise": "번역을 위한 페이지 및 웹사이트 컨텍스트"
          }
        }
      },
      "botom_banner": {
        "title": "차원이 다른 번역 정확도를 경험하세요",
        "sub_title": "새로운 Linguise AI 번역",
        "description": "Linguise는 최신 AI 번역 LLM(번역에 최적화된 최신 Llama 모델)을 활용한 강력한 새로운 옵션인 Linguise AI 번역을 도입하여 자동 번역 서비스를 강화합니다. 이 추가 기능은 웹사이트 개발자와 웹 에이전시에게 완벽이 중요한 프로젝트에 이상적인 한 단계 높은 번역 품질을 제공합니다. Linguise AI 번역은 기존의 고품질 Google Cloud AI 번역을 보완하여 더욱 뛰어난 유연성과 정밀함을 제공합니다."
      }
    },
    "success": {
      "tab_title": "AI 번역 요금제를 구매해 주셔서 감사합니다!",
      "title": "AI 번역 요금제를 구매해 주셔서 감사합니다!",
      "subtitle": "AI 번역 요금제를 성공적으로 구매했습니다!",
      "message": "AI 번역 설정 페이지에서 AI 번역 요금제를 관리할 수 있습니다.",
      "home": "AI 번역 관리"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "이름",
        "description": "청구 계정 이름"
      },
      "phone": {
        "title": "전화번호",
        "description": "청구 계정 전화번호"
      },
      "email": {
        "title": "이메일",
        "description": "청구 계정 이메일"
      },
      "address": {
        "title": "주소",
        "description": "청구 계정 주소",
        "city": "도시",
        "country": "국가",
        "address1": "주소 1",
        "address2": "주소 2",
        "postal": "우편 번호",
        "state": "주"
      },
      "tax": {
        "title": "세금 번호"
      }
    }
  },
  "checkouts": {
    "header": "결제",
    "payment_method": "결제 수단 선택",
    "stripe_card": "신용카드(Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "새로운 청구지 주소 입력",
      "existing": "기존 주소 사용"
    },
    "pay_stripe": "확인 및 결제",
    "terms": "구독을 확인하면 향후 결제에 대해 당사 약관에 따라 Linguise가 요금을 청구하는 것을 허용합니다. 언제든지 구독을 취소할 수 있습니다.",
    "coupon": {
      "title": "쿠폰이 있으신가요?",
      "placeholder": "여기에 쿠폰 코드를 입력하세요",
      "apply": "적용",
      "percent": "{{0}}% 할인"
    },
    "add_new": "새로 추가",
    "use_existing": "기존 결제 수단 사용",
    "recurring": {
      "month_single": "매월 청구",
      "month_many": "{{count}}개월마다 청구",
      "year_single": "매년 청구",
      "year_many": "{{count}}년마다 청구",
      "day_single": "매일 청구",
      "day_many": "{{count}}일마다 청구",
      "week_single": "매주 청구",
      "week_many": "{{count}}주마다 청구"
    },
    "add_new_no_stripe": "새 카드 추가",
    "summary": {
      "title": "요약",
      "subtotal": "소계",
      "total": "합계"
    }
  },
  "dashboard": {
    "main": {
      "title": "대시보드"
    },
    "statistics": {
      "main_title": "최근 30일 통계",
      "characters": "번역된 글자 수",
      "words": "번역된 단어 수",
      "bandwidth": "입력 대역폭",
      "request": "요청 수",
      "page_views": "언어별 페이지 뷰(최근 30일)",
      "multilingual_views": "다언어 페이지 뷰(최근 30일)",
      "most_page_viewed": "가장 많이 조회한 페이지 20개(최근 30일)",
      "no_data_yet": "아직 이용 가능한 데이터가 없습니다",
      "th_language": "언어",
      "th_page_views": "페이지 뷰",
      "real_visitors": "실제 방문자",
      "crawler": "웹 크롤러"
    },
    "planHints": {
      "subscribeButton": "구독",
      "upgradeButton": "업그레이드",
      "usedWords": "현재 {words_used} 단어를 사용 중입니다",
      "noPlan": "이 도메인에 대해 활성화된 요금제가 없습니다. 요금제를 구독하고 웹사이트 번역을 시작하세요",
      "noPlanShopify": "이 도메인에 대해 활성화된 요금제가 없습니다. Shopify 대시보드에서 요금제를 구독하고 웹사이트 번역을 시작하세요",
      "trialUsage": "현재 체험 요금제에 포함된 {words_allowed} 단어 중 {words_used} 단어를 사용 중입니다.",
      "trialEnds": "1개월 체험 기간이 {trial_ends}까지 활성화되어 있습니다.",
      "subscribeMessage": "만료 전에 구독하여 웹사이트 번역을 유지하세요",
      "subscribeMessageShopify": "Shopify 대시보드에서 만료 전에 구독하여 웹사이트 번역을 유지하세요",
      "trialReachedLimit": "체험 기간의 최대 번역 단어 수에 도달했습니다.\n웹사이트 번역을 계속하려면 요금제에 구독하세요.",
      "paidUsage": "요금제에서 {words_allowed} 단어 중 {words_used} 단어를 사용했습니다.",
      "paidReachedLimit": "현재 요금제의 최대 번역 단어 수에 도달했습니다.\n웹사이트 콘텐츠 번역을 계속하려면 요금제를 업그레이드하세요.",
      "trialOfferedUsage": "현재 체험 요금제에 포함된 {words_allowed} 단어 중 {words_used} 단어를 사용 중입니다.({free_words} 단어 추가 제공 포함)",
      "paidOfferedUsage": "요금제에서 {words_allowed} 단어 중 {words_used} 단어를 사용했습니다.({free_words} 단어 추가 제공 포함)",
      "noPlanExtra": "비활성 도메인과 해당 데이터는 정기적으로 자동 삭제됩니다.",
      "planRecommended": "현재 번역량 기반 권장 요금제:",
      "planMaximumWords": "{{words}} 단어",
      "notHaveTranslatedWords": "아직 번역한 단어가 없습니다"
    },
    "translationSetup": {
      "kicker": "하위 도메인 설정",
      "title": "번역 설정 확인",
      "description": "DNS, 번역된 호스트, 원본 사이트 액세스 및 계정 한도를 확인하세요.",
      "starting": "확인 중...",
      "button": "설정 확인",
      "viewLatest": "최신 결과 보기",
      "viewCurrent": "현재 검사 보기",
      "runAgain": "다시 검사",
      "viewDetails": "세부 정보 보기",
      "hideDetails": "세부 정보 숨기기",
      "error": "설정을 확인할 수 없습니다",
      "allPassed": "모든 검사를 통과했습니다",
      "setupNeedsAttention": "설정을 확인해야 합니다",
      "setupNeedsAttentionDescription": "하나 이상의 검사에 실패했습니다. 아래 항목을 확인하거나 Linguise 지원팀에 문의하세요.",
      "lastChecked": "마지막 확인 {{time}}",
      "domainOwnership": "도메인 소유권",
      "domainOwnershipDescription": "확인 레코드를 찾았습니다",
      "domainOwnershipFailure": "소유권 DNS 레코드를 확인하지 못했습니다.",
      "translatedHosts": "번역된 호스트",
      "translatedHostsDescription": "언어 호스트 {{count}}개 확인",
      "translatedHostsFailure": "하나 이상의 언어 CNAME 레코드가 올바르지 않습니다.",
      "subdomainPage": "하위 도메인 페이지",
      "subdomainPageDescription": "번역된 페이지 {{count}}개에서 HTTPS를 사용할 수 있습니다",
      "subdomainPageFailure": "번역된 페이지를 여는 중 TLS 연결에 실패했습니다.",
      "originalSite": "원본 사이트",
      "originalSiteDescription": "원본 사이트 DNS, TLS 및 응답 검사",
      "originalSiteFailure": "원본 사이트 DNS, TLS 또는 응답 검사에 실패했습니다.",
      "documentationAdvice": {
        "dns": "DNS 설정 검토",
        "tls": "HTTPS 설정 검토",
        "origin": "원본 사이트 설정 검토",
        "diagnostic": "문제 해결 단계 검토"
      },
      "evidence": {
        "originDns": "원본 DNS",
        "originTls": "원본 TLS",
        "originHttp": "원본 응답",
        "observedTargets": "감지된 대상",
        "recordCount": "발견된 레코드",
        "addressCount": "발견된 주소",
        "statusCode": "HTTP 상태",
        "redirect": "리디렉션",
        "expiresAt": "인증서 만료",
        "raw": "{{key}}",
        "noValue": "값 없음"
      },
      "checkerError": "일부 검사를 완료할 수 없습니다.",
      "coreLocation": "{{location}}에서 확인",
      "status": {
        "queued": "대기 중",
        "running": "실행 중",
        "completed": "완료",
        "failed": "실패",
        "passed": "통과",
        "warning": "경고",
        "unknown": "알 수 없음",
        "skipped": "건너뜀",
        "not_applicable": "해당 없음"
      }
    },
    "throttling": {
      "title": "번역 제한",
      "description": "임시 사용량 제한",
      "unavailable": "임시 번역 한도를 사용할 수 없습니다",
      "window": "{{used}} / {{max}}단어",
      "resetsIn": "{{time}} 후 재설정",
      "throttled": "번역이 일시 중지되었습니다",
      "throttledDescription": "임시 사용량 한도에 도달했습니다. 이 기간이 재설정되면 번역이 다시 시작됩니다."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "{{total}}단계 중 {{step}}단계",
      "doneLabel": "완료되었습니다, 이제 번역을 시작하세요!",
      "finish": {
        "title": "",
        "description": "웹사이트에서 사용할 API 키입니다"
      },
      "instructions": "설치 안내",
      "domainSetting": "도메인 설정",
      "step": {
        "titleWordpress": "워드프레스",
        "titleJoomla": "줌라",
        "titlePHP": "PHP 스크립트",
        "wizardWordpressStep1": "1. ",
        "wizardWordpressStep2": "플러그인 설정에서 API 키를 복사하여 입력하세요\n",
        "wizardWordpressStep3": "3. 번역을 시작할 수 있습니다\n\n",
        "wizardWordpressStep4": "보다 자세한 설명은 저희 문서를 참고해 주세요: ",
        "wizardJoomlaStep1": "1. Joomla 패키지 링크: ",
        "wizardJoomlaStep2": "\n2. 확장 구성 설정에서 API 키를 복사하여 입력하세요",
        "wizardJoomlaStep3": "3. 모듈 구성에서 표시할 언어를 설정하고 필요한 위치에 모듈을 삽입하세요.",
        "wizardJoomlaStep4": "\n4. 이제 번역을 시작할 수 있습니다\n\n",
        "wizardPhpStep1": "1. PHP 스크립트를 다운로드하세요 ",
        "wizardPhpStep2": "\n2. 설치 안내는 저희 문서 페이지를 따라 주세요 ",
        "wizardPhpStep3": "3. 페이지에 모듈을 추가하세요.",
        "wizardPhpStep4": "\n 아래 코드를 복사해 HTML 페이지의 head에 추가하시면 전환 모듈이 자동으로 표시됩니다\n",
        "dispatchStep1": "필요한 데이터를 Linguise 플러그인으로 전송했습니다. 이제 창을 닫으셔도 됩니다.",
        "dispatchStep2": "이 창을 닫았을 때 토큰이 누락되었다면 아래 토큰을 복사해 주세요:",
        "dispatchStep3": "깃발 스위처를 자동으로 활성화할 수 있는 코드도 복사하실 수 있습니다",
        "wizardOtherStep1": "도메인에 Linguise를 설치하려면 아래 지침을 따르세요.\n",
        "wizardOtherStep2": "아래 코드를 복사해 HTML 페이지의 head에 추가하시면 전환 모듈이 자동으로 표시됩니다.\n"
      },
      "trialAlreadyUsed": "무료 평가판을 이미 사용하셨습니다. 번역 할당량이 필요합니다\n플랜을 구독하거나 연장을 원하시면 저희에게 문의해 주세요.",
      "usefulLinks": "시작에 유용한 링크",
      "linkDocumentation": "문서",
      "linkExtensionDl": "확장 다운로드",
      "linkSubscribe": "지금 플랜 구독하기",
      "linkDashboard": "대시보드로 이동",
      "exclusion": {
        "title": "회사 및 제품 이름",
        "description": ""
      },
      "finishButton": "설정 완료",
      "subdomains": "서브도메인",
      "subdomain_setup": "도메인 설정",
      "subdomain_auto_setup": "DNS 자동 연결",
      "subdomain_manual_setup": "DNS 수동 추가",
      "subdomain_skip": "나중에 하기",
      "auto_subdomains_info": "사이트 빌더 CMS는 언어별 서브도메인(예: ko.domain.com) 설정을 위해 DNS 구성이 필요합니다.",
      "auto_subdomains_info_2": "‘DNS 자동 연결’ 버튼을 클릭해 Entri로 DNS 관리자에 연결하고 DNS 레코드를 추가할 수 있습니다.",
      "auto_subdomains_info_manual": "또는 ‘DNS 수동 추가’ 버튼을 클릭해 도메인을 직접 구성하세요.",
      "breadcrumbs": {
        "step1": "1단계: 도메인, CMS 및 언어",
        "step2": "2단계: 언어 DNS",
        "step3": "단계 {{step}}: 설치 지침"
      }
    },
    "form": {
      "urls": {
        "dash": "대시(-)",
        "underscore": "언더스코어(_)",
        "title": "URL 번역",
        "description": "모든 페이지를 번역하시겠습니까",
        "char_description": "URL에서 허용되지 않는 문자를 대체할 문자",
        "advertisement_title": "⚠언어를 너무 많이 설정하셨습니다.\n",
        "advertisement": "웹사이트 번역은 처음에 소수의 언어부터 시작하는 것이 좋습니다. 이렇게 하면 웹사이트의 단어 수를 파악할 수 있으며, 구글 봇이 빠르게 모든 페이지를 크롤링할 수 있어 SEO에도 유리합니다. 일주일 후 더 많은 언어를 추가할 수 있습니다."
      },
      "url": {
        "title": "URL",
        "description": "기본 도메인 URL을 http:// 또는 https://로 시작해 입력하세요",
        "placeholder": "도메인 URL",
        "advertisement_http": {
          "title": "https 프로토콜을 사용하지 않고 있습니다",
          "description": "도메인이 실제로 https를 사용하지 않는지 확인해 주세요. 현재는 https 사용을 권장합니다."
        },
        "advertisement_www": {
          "title": "서브도메인이 www가 아닙니다",
          "description": "대부분의 경우 기본 서브도메인은 www입니다(https://www.mydomain.com같이). 상황에 따라 다를 수 있지만 추가하려는 도메인이 맞는지 다시 확인해 주세요."
        },
        "invalid_url": {
          "line1": "도메인을 찾을 수 없습니다. 도메인이 인터넷에 공개되어 있고 다른 위치로 리디렉션되지 않는지 확인하세요.",
          "line2": "도메인에 정상적으로 접근할 수 있다면 도메인 확인을 건너뛰고 ‘다음 단계’ 버튼을 다시 누르세요",
          "contact": "필요시 저희에게 연락해 주세요",
          "force": "도메인 확인 건너뛰기"
        },
        "invalid_subdomain_url": "이 URL은 허용되지 않습니다. 서브도메인은 https://www.domain.tld 또는 하위 디렉터리가 없는 https://domain.tld 형식이어야 합니다."
      },
      "account": {
        "title": "계정",
        "description": "이 도메인을 할당할 계정을 선택하세요",
        "placeholder": "계정 선택...",
        "feedback": "계정을 선택해야 합니다"
      },
      "platform": {
        "title": "플랫폼",
        "description": "웹사이트 플랫폼을 CMS 이름으로 검색해 선택하세요.",
        "learn": "선택 방법 알아보기",
        "placeholder": "CMS 이름으로 플랫폼 검색...",
        "info": {
          "title": "⚠이 플랫폼은 최근에 추가되었습니다.\n",
          "desc": "이 웹사이트 빌더 플랫폼은 Linguise에서 지원되며 최근에 추가되었습니다. 문제가 발생할 경우 아래 직접 지원 이메일로 연락해 주세요:"
        },
        "description_read_only": "웹사이트에서 사용 중인 플랫폼",
        "feedback": "플랫폼을 선택해야 합니다"
      },
      "language": {
        "title": "언어",
        "description": "웹사이트의 기본 언어를 선택하세요",
        "placeholder": "언어 선택...",
        "feedback": "언어를 선택해야 합니다",
        "description_read_only": "웹사이트의 기본 언어"
      },
      "token": {
        "title": "API 키",
        "description": "웹사이트에 복사할 API 키입니다",
        "copy": "클립보드에 복사",
        "reset": "API 키 재설정",
        "reset_confirm": "API 키 재설정을 확인해 주세요"
      },
      "languages": {
        "title": "번역 언어",
        "description": "웹사이트를 번역할 언어를 선택하세요",
        "placeholder": "언어 선택...",
        "feedback": "언어를 선택해야 합니다"
      },
      "defaultRules": {
        "title": "기본 규칙",
        "description": "번역 향상 및 워드프레스 대시보드 같은 원하지 않는 콘텐츠 번역 방지를 위해 필수 규칙 세트를 정의했습니다.\n이 규칙들은 나중에 제거하거나 수정할 수 있습니다."
      },
      "disallow_deletion": "구독이 활성화된 도메인은 삭제할 수 없습니다",
      "delete_confirm": "도메인 삭제를 확인해 주세요",
      "delete": "도메인 삭제",
      "dynamic": {
        "title": "동적 콘텐츠 번역",
        "description": "JavaScript 및 AJAX 요청으로 생성된 동적 콘텐츠를 번역합니다(이 옵션은 번역 사용량이 증가합니다)"
      },
      "partial_translations": {
        "title": "부분 번역 허용",
        "description": "계정의 번역 할당량이 도달했지만 페이지에 번역이 필요한 경우 Linguise가 이미 번역된 콘텐츠로 페이지를 계속 표시할 수 있습니다.\n하지만 일부 콘텐츠는 할당량을 업그레이드할 때까지 번역되지 않은 상태로 유지됩니다.\n\n소량의 미번역 콘텐츠는 SEO에 해가 되지 않지만, 너무 많은 미번역 콘텐츠는 사용자 경험에 부정적 영향을 줄 수 있습니다.\n이를 해결하기 위해 페이지에서 허용할 미번역 콘텐츠 비율 임계값을 설정할 수 있습니다. 임계값을 초과하면 사용자가 자동으로 원본 언어 페이지로 리디렉션됩니다.",
        "never": "허용 안 함"
      },
      "translate_error_pages": {
        "title": "오류 페이지 번역",
        "description": "Linguise는 모든 오류 페이지를 번역할 수 있습니다. 단, 오류 페이지에 IP 주소나 요청 ID 같은 동적 콘텐츠가 포함되어 있다면 번역을 피해야 합니다.",
        "not_found_page": {
          "title": "404 페이지 번역"
        },
        "error_page": {
          "title": "기타 오류 페이지 번역"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "기존 도메인 발견",
          "description": "해당 사용자에 대한 기존 도메인이 발견되었습니다. 사용하시겠습니까?"
        }
      },
      "search_tl": {
        "title": "번역 검색",
        "description": "웹사이트 플랫폼에서 번역 검색을 활성화합니다(실험적 기능으로 번역 사용량이 증가합니다)"
      },
      "shopify_promo": {
        "info": "좋은 소식입니다! 이제 Shopify 앱 스토어에서 설치할 수 있는 Shopify 네이티브 앱이 출시되었습니다.",
        "hyperlink": "여기를 클릭하고 앱에서 Linguise를 설치하세요.",
        "next_btn": "Shopify 스토어로 이동하여 앱을 설치하세요.",
        "info_legacy": "좋은 소식입니다! 이제 Shopify 앱 스토어에서 설치할 수 있는 Shopify 네이티브 앱이 출시되었습니다.",
        "description_legacy": "\"Shopify Legacy\" 대신 \"Shopify\" 플랫폼을 선택하세요."
      },
      "wix_promo": {
        "info": "좋은 소식입니다! 이제 Wix 앱 마켓에서 설치할 수 있는 Wix 네이티브 앱이 출시되었습니다.",
        "hyperlink": "여기를 클릭하고 앱에서 Linguise를 설치하세요.",
        "next_btn": "Wix 앱 마켓으로 이동하여 앱을 설치하세요.",
        "info_legacy": "좋은 소식입니다! 이제 Wix 앱 마켓에서 설치할 수 있는 Wix 네이티브 앱이 출시되었습니다.",
        "description_legacy": "\"Wix Legacy\" 대신 \"Wix\" 플랫폼을 선택하세요."
      },
      "ai_disallow_deletion": "AI 할당량을 아직 사용할 수 있는 동안에는 이 도메인을 삭제할 수 없습니다.\n\n이 도메인을 삭제하려면 지원팀에 문의하세요.",
      "language_removal": {
        "card": {
          "title": "삭제한 언어의 번역 삭제",
          "description": "웹사이트에서 삭제한 언어의 번역이 저장되어 있어 아직 할당량에 포함됩니다. 번역을 삭제하면 해당 단어 수를 할당량으로 돌려받습니다.",
          "button": "번역 삭제"
        },
        "hint": "사용된 단어 수가 할당량으로 반환됩니다. 웹사이트마다 {{days}}일에 한 번 실행할 수 있습니다.",
        "modal": {
          "title": "번역을 삭제할까요?",
          "intro": "다음 번역이 영구적으로 삭제됩니다:",
          "warning": "이 작업은 되돌릴 수 없습니다. 사용된 단어 수가 할당량으로 반환되기까지 몇 분 정도 걸릴 수 있습니다.",
          "limit": "웹사이트마다 {{days}}일에 한 번 실행할 수 있습니다.",
          "confirm": "번역 삭제"
        },
        "scheduled": "번역을 삭제하고 있습니다. 곧 할당량이 업데이트됩니다.",
        "cooldown": "이 웹사이트의 번역은 최근 삭제되었습니다. {{date}}에 다시 삭제할 수 있습니다.",
        "latest_completed": {
          "title": "최근 완료된 삭제",
          "description": "삭제된 언어와 할당량으로 반환된 단어 수를 확인하세요.",
          "languages": "삭제된 언어",
          "words_returned": "할당량으로 반환된 단어: {{words}}",
          "completed_at": "{{date}}에 완료"
        },
        "status": {
          "recent_title": "최근 번역 삭제",
          "recent_description": "최근 삭제 상태와 다음 삭제 가능 시점을 확인하세요.",
          "progress_title": "삭제 진행률",
          "loading": "삭제 진행률을 확인하는 중...",
          "unavailable": "삭제 진행률을 불러오지 못했습니다. 페이지를 새로고침하고 다시 시도하세요.",
          "label": "상태",
          "pending": "대기열",
          "processing": "진행 중",
          "completed": "완료",
          "failed": "실패",
          "unknown": "상태를 사용할 수 없음",
          "percent": "{{percent}}% 완료",
          "current_stage": "현재 단계: {{stage}}",
          "processed": "{{processed}}개 레코드 처리됨",
          "processed_total": "{{total}}개 중 {{processed}}개 레코드 처리됨",
          "requested_at": "{{date}} 요청",
          "started_at": "{{date}} 시작",
          "completed_at": "{{date}}에 완료",
          "cooldown_period": "웹사이트마다 {{days}}일에 한 번 실행할 수 있습니다.",
          "cooldown_blocked": "아직 다른 삭제를 시작할 수 없습니다.",
          "stage": {
            "queued": "시작 대기 중",
            "processing": "진행 중",
            "refund_summary": "반환 단어 계산 중",
            "search_translations": "검색 번역 삭제 중",
            "url_translations": "URL 번역 삭제 중",
            "translations": "번역 삭제 중",
            "completed": "완료",
            "failed": "실패",
            "unknown": "진행 중"
          }
        },
        "forbidden": "번역을 삭제할 권한이 없습니다."
      }
    },
    "main": {
      "edit": "도메인 수정",
      "add": "도메인 추가",
      "wizard": "환영합니다! 새 도메인 생성 마법사",
      "common": "도메인"
    },
    "notice": {
      "broken_card": "현재 결제 수단으로 {{url}} 플랜을 갱신하지 못했습니다. 결제 카드를 업데이트해 주세요",
      "quota_reached": "{{url}}의 번역 할당량이 도달했습니다. 웹사이트 번역을 재개하려면 업그레이드해 주세요",
      "ai_no_subscription": "{{url}}의 AI 번역을 사용하려면 유효한 구독 또는 평가판이 필요합니다. 없으면 중단되므로 계속하려면 업그레이드해 주세요",
      "important": "중요",
      "quota_reached_button": "지금 요금제를 업그레이드하세요",
      "broken_card_button": "결제 카드 정보를 업데이트하세요",
      "ai_no_subscription_button": "지금 요금제를 업그레이드하세요",
      "quota_warning": "{{url}}에 대한 번역 할당량이 {{throttling_used_percent}}%에 도달했습니다. 할당량은 {{ttl}} 후에 초기화됩니다.",
      "locked": "{{url}} 도메인은 현재 이전을 위해 잠겨 있습니다. 사이트에 계속 액세스할 수는 있지만 새 번역을 편집하거나 추가할 수는 없습니다!"
    },
    "subdomains": {
      "config_ok": "서브도메인 DNS가 올바르게 설정되었습니다.",
      "config_invalid": "서브도메인 DNS가 작동하려면 추가 설정이 필요합니다.",
      "config_check": "서브도메인 DNS 설정을 확인 중입니다. 잠시 기다려 주세요...",
      "entri_timeout": "Entri에서 서브도메인 DNS 전파 과정이 시간 초료되었다고 보고했습니다. 다시 시도하거나 수동으로 진행해야 합니다.",
      "entri_process": "DNS가 Entri를 통해 추가되었으며, 일반적으로 전파(예: es.domain.com 같은 모든 언어 서브도메인 적용)까지 10-30분이 소요됩니다. 24시간이 지나도 DNS 검증이 완료되지 않으면 support@linguise.com으로 지원팀에 문의하세요.",
      "entri_ok": "DNS 전파 진행 중입니다! 전파를 기다리는 중...",
      "infos": "변환을 활성화하려면 이러한 DNS 항목을 DNS 도메인 레코드에 추가해야 합니다. 완료되면 확인 버튼을 클릭하십시오. DNS 레코드가 적용되는 데 시간이 걸릴 수 있으므로 몇 분 또는 몇 시간 후에 다시 확인하십시오.",
      "check": "DNS 구성을 확인하세요"
    },
    "subscription": {
      "next_payment_amount": "다가오는 요금",
      "next_payment_date": "다음 결제일",
      "invoice": {
        "header": "청구 내역",
        "date": "날짜",
        "amount_due": "금액",
        "status": "상태",
        "actions": "작업",
        "description": "거래가 발생하면 여기에서 확인할 수 있습니다.",
        "status_text": {
          "draft": "초안",
          "failed": "실패",
          "open": "보류 중",
          "paid": "지급 완료",
          "retrying": "재시도 중",
          "uncollectible": "수금 불가",
          "void": "무효"
        },
        "view": "보기",
        "empty": "이 구독에 대한 최근 청구서를 찾을 수 없습니다.",
        "retry_payment": "재시도"
      },
      "next_cancellation": "취소 예정일",
      "cancel": "구독 취소",
      "change_plan": "요금제 변경",
      "change": "변경",
      "suspend": "결제 일시 중지",
      "resume": "구독 재개",
      "back": "뒤로",
      "save": "저장",
      "confirm_resume": "이 구독을 재개하시겠습니까?",
      "confirm_cancel": "이 구독을 취소하시겠습니까?",
      "confirm_header": "정말 하시겠습니까?",
      "missing_status": "이 구독을 찾을 수 없습니다.",
      "not_found": "이 도메인에 대한 구독을 찾을 수 없습니다",
      "confirm_manual_retry": "이 결제를 재시도하시겠습니까?",
      "no_payment_method": "알 수 없음",
      "remove_billing": "제거",
      "shopify_maneged": "이 구독은 Shopify에서 관리됩니다. Shopify 관리 패널에서 관리해 주세요.",
      "unknown_plan": "알 수 없는 요금제"
    }
  },
  "domain_listing": {
    "add": "웹사이트 추가",
    "select": "도메인 선택"
  },
  "editable": {
    "number": "번호 {{id}}"
  },
  "footer": {
    "about": "소개",
    "support": "지원"
  },
  "frontendEditor": {
    "main": "라이브 에디터",
    "description": "라이브 에디터를 통해 웹사이트에서 번역을 바로 수정할 수 있습니다.",
    "button": "라이브 에디터 열기",
    "language_selection": "번역 언어 선택",
    "video_label": "라이브 에디터 사용법 배우기"
  },
  "general": {
    "403": {
      "tab_title": "이런 - 403 오류",
      "title": "접근 거부",
      "message": "요청하신 페이지에 접근할 권한이 없는 것 같습니다.",
      "home": "홈으로 돌아가기"
    },
    "404": {
      "tab_title": "이런 - 404 오류",
      "title": "페이지를 찾을 수 없음",
      "message": "잘못된 경로로 들어오신 것 같습니다. 걱정 마세요... 누구에게나 일어날 수 있어요. 다시 올바른 길로 돌아가기 위한 작은 도움말이 있습니다.",
      "home": "홈으로 돌아가기"
    },
    "500": {
      "tab_title": "500 오류",
      "title": "내부 서버 오류",
      "message": "페이지를 새로 고쳐 보시거나 저희에게 연락해 주세요.",
      "home": "홈으로 돌아가기"
    },
    "fields": {
      "alert": "일부 필드가 유효하지 않습니다. 잘못된 필드를 수정해 주세요.",
      "invalid": "이 필드가 유효하지 않습니다.",
      "phone_re": "전화번호가 유효하지 않습니다.",
      "phone_invalid": "전화번호가 유효하지 않습니다.",
      "email": "이메일 입력란이 유효하지 않습니다."
    },
    "table": {
      "no_data": "아직 데이터가 없습니다..."
    },
    "saving": "저장 중...",
    "save": "저장",
    "save_and_quit": "저장하고 나가기",
    "invite": "초대",
    "cancel": "취소",
    "yes": "예",
    "no": "아니오",
    "nextStep": "다음 단계",
    "loading": "애플리케이션 로딩 중입니다. 잠시만 기다려 주세요.",
    "goback": "뒤로 가기",
    "manage": "관리",
    "delete": "삭제",
    "deleting": "삭제 중...",
    "confirm": "확인",
    "unknown": "알 수 없음",
    "hide": "숨다",
    "show": "보여주다",
    "on": "~에",
    "off": "끄다",
    "default": "기본값"
  },
  "home": {
    "header": "홈",
    "manage": "구독 관리",
    "canceled": "취소 예약됨",
    "activate_now": "지금 활성화",
    "activate_plan_now": "지금 구독",
    "upgrade_plan_now": "지금 요금제 업그레이드",
    "trial_message_part_1": "현재 체험 요금제를 사용 중입니다, ",
    "trial_message_part_2": "언제든지 멤버십을 활성화할 수 있습니다.",
    "add": "도메인 추가",
    "table": {
      "title": "도메인",
      "description": "도메인 목록입니다. 도메인을 클릭해 번역을 관리하세요."
    },
    "domains": {
      "empty": "이 계정에 도메인이 없습니다."
    },
    "accountsList": {
      "title": "계정",
      "add": "새 계정 추가",
      "name": "계정 이름"
    },
    "update_credit_card": "신용카드 정보 업데이트",
    "cancelling_subs": "{{0}}에 취소됨",
    "resume_subscription": "구독 재개",
    "shopify_managed": "Shopify에서 관리됨",
    "trial_ends_at": "{{0}}에 끝남",
    "free_trial": "무료 평가판",
    "no_subs": "활성 구독 없음"
  },
  "invoices": {
    "title": "송장",
    "list": {
      "title": "송장 목록"
    },
    "table": {
      "customer": "고객",
      "domain": "도메인",
      "amountPaid": "지불 금액",
      "status": "상태",
      "date": "날짜",
      "invoice": "송장",
      "pay": "송장 지불",
      "actions": "작업",
      "deleted_domain": "도메인 삭제됨",
      "plan_name": "요금제",
      "action": "작업"
    },
    "listPending": {
      "title": "보류 중인 송장 목록"
    }
  },
  "language_settings": {
    "display": "언어 목록 표시",
    "position": "위치",
    "display_help_text": "국기 및/또는 언어 이름을 표시합니다. 언어 전환기 기본 위치는 콘텐츠 내 어디든지 또는 스크롤 시 고정되거나 움직이는 고정 위치일 수 있습니다",
    "side_by_side": "나란히",
    "dropdown": "드롭다운",
    "popup": "팝업",
    "flag": "국기",
    "lang_name": "언어 이름",
    "lang_short_name": "짧은 이름",
    "positions": {
      "in_place": "제자리",
      "top_left": "왼쪽 위",
      "top_left_no_scroll": "왼쪽 위(스크롤 없음)",
      "top_right": "오른쪽 위",
      "top_right_no_scroll": "오른쪽 위(스크롤 없음)",
      "bottom_left": "왼쪽 아래",
      "bottom_left_no_scroll": "왼쪽 아래(스크롤 없음)",
      "bottom_right": "오른쪽 아래",
      "bottom_right_no_scroll": "오른쪽 아래(스크롤 없음)"
    },
    "lang_names_display": {
      "title": "언어 이름 표시",
      "help_text": "언어 전환기에서 언어 이름을 영어로 표시할지 또는 원래 언어로 표시할지, 예: French 또는 Français",
      "english": "영어",
      "native_languages": "원래 언어"
    },
    "flag_shape": {
      "title": "국기 스타일",
      "help_text": "둥근 svg 또는 직사각형 svg 국기 아이콘 사용",
      "round": "둥근",
      "rectangular": "직사각형"
    },
    "english_flag_type": {
      "title": "영어 국기 유형",
      "help_text": "영어용 국기로 영국 또는 미국 국기 사용",
      "usa": "미국 국기",
      "great_britain": "영국 국기"
    },
    "german_flag_type": {
      "title": "독일어 국기 유형",
      "help_text": "독일어용 국기로 오스트리아 또는 독일 국기 사용",
      "german": "독일 국기",
      "austria": "오스트리아 국기"
    },
    "spain_flag_type": {
      "title": "스페인어 국기 유형",
      "help_text": "스페인어용 국기로 멕시코 또는 스페인 국기 사용",
      "spanish": "스페인 국기",
      "mexico": "멕시코 국기",
      "peruvian": "페루 국기"
    },
    "portugal_flag_type": {
      "title": "포르투갈어 국기 유형",
      "help_text": "포르투갈어용 국기로 포르투갈 또는 브라질 국기 사용",
      "portugal": "포르투갈 국기",
      "brazil": "브라질 국기"
    },
    "taiwanese_flag_type": {
      "title": "대만어 국기 유형",
      "help_text": "대만어용 국기로 대만 또는 중국 국기 사용",
      "taiwanese": "대만 국기",
      "chinese": "중국 국기"
    },
    "flag_border_radius": {
      "title": "국기 모서리 반경(px)",
      "help_text": "직사각형 국기 모양을 사용하는 경우 픽셀 단위로 사용자 지정 모서리 반경을 적용할 수 있습니다"
    },
    "flag_width": {
      "title": "국기 크기(px)",
      "help_text": "픽셀 단위로 국기 크기 선택. svg 형식이므로 이미지 무게는 변경되지 않습니다"
    },
    "lang_color": {
      "color_title": "언어 이름 색상",
      "color_help_text": "언어 이름의 기본 텍스트 색상 선택",
      "hover_color_title": "언어 이름 마우스 오버 색상",
      "hover_color_help_text": "언어 이름의 마우스 오버 텍스트 색상 선택",
      "color_popup_title": "팝업 언어 색상",
      "color_popup_help_text": "팝업 또는 드롭다운 영역의 언어 제목 색상",
      "hover_color_popup_title": "팝업 언어 마우스 오버 색상",
      "hover_color_popup_help_text": "팝업 또는 드롭다운 영역의 언어 제목 마우스 오버 텍스트 색상 선택"
    },
    "flag_box_shadow": {
      "shadow_title": "국기 그림자",
      "shadow_help_text": "국기의 색상 및 그림자 크기",
      "hover_shadow_title": "마우스 오버 시 국기 그림자",
      "hover_shadow_help_text": "마우스 오버 시 국기의 색상 및 그림자 크기",
      "shadow_h_offset": "그림자 수평 오프셋(px)",
      "shadow_v_offset": "그림자 수직 오프셋(px)",
      "shadow_blur": "그림자 흐림(px)",
      "shadow_spread": "그림자 퍼짐(px)",
      "shadow_color": "그림자 색상"
    },
    "order": "언어 순서",
    "language_order_help": "언어 전환기에 표시될 언어 순서. 드래그 앤 드롭하여 순서를 변경할 수 있습니다.",
    "order_reset": "순서 재설정",
    "language_order_dragdrop": "드래그 앤 드롭하여 언어 순서를 변경할 수 있습니다.",
    "popup_lang_name": "팝업 언어 이름",
    "preview": "언어 미리보기"
  },
  "link": {
    "form": {
      "original": {
        "title": "원본 소스",
        "description": "원본 링크 URL을 추가하고 아래에서 언어별로 번역하여 대체하세요",
        "srcset_description": "이미지 URL을 수정 중입니다. srcset을 사용하거나 이게 무엇인지 모르는 경우 문서를 반드시 읽어 주세요",
        "link": "링크",
        "match_link": "일치 모드",
        "match_exact": "정확히",
        "match_wildcard": "와일드카드",
        "match_regex": "정규식"
      },
      "alternative_languages": {
        "title": "교체할 링크",
        "description": "언어별로 페이지 전체의 미디어 링크와 외부 링크를 교체합니다…",
        "link": "교체할 링크"
      },
      "error": {
        "atLeastOne": "최소한 하나의 번역을 추가하세요.",
        "url": "URL이 유효하지 않습니다",
        "extension": "링크는 확장자를 가져야 하며, .html이나 .php일 수 없습니다. 또한 링크에는 \"/fr\" 같은 언어 경로가 포함되어서는 안 됩니다",
        "regex": "정규식이 유효하지 않습니다",
        "wildcard": "와일드카드 링크의 프로토콜이 유효하지 않습니다"
      }
    },
    "main": {
      "parent": "링크",
      "edit": "링크 편집"
    }
  },
  "links": {
    "title": "미디어 및 외부 링크 관리",
    "description": "웹사이트의 미디어 링크나 외부 링크를 목록화하고 편집하세요.",
    "add": "링크 추가",
    "delete": "링크 삭제",
    "table": {
      "original": "원본",
      "language": "언어",
      "translation": "번역",
      "action": "작업",
      "delete_confirm": "링크 삭제를 확인해 주세요"
    }
  },
  "members": {
    "header": "멤버",
    "invite": "새 멤버 초대",
    "modal": {
      "inviteHeader": "새 멤버 초대",
      "editHeader": "멤버 편집",
      "detachHeader": "멤버 분리",
      "detachBody": "이 멤버를 계정에서 분리하시겠습니까?",
      "selfDetachBody": "계정 관리에서 자신을 분리하시겠습니까? 이 후에는 이 계정 관련 데이터에 접근할 수 없습니다."
    },
    "table": {
      "title": "멤버 목록",
      "description": "멤버 역할 및 도메인 접근 권한",
      "name": "이름",
      "email": "이메일",
      "websites": "웹사이트",
      "languages": "언어",
      "role": "역할",
      "status": "상태",
      "resendInvite": "재전송",
      "inviteSent": "초대장이 전송됨",
      "actions": "작업",
      "edit": "편집",
      "detach": "분리",
      "empty": "아직 멤버가 없습니다",
      "all_website": "모든 웹사이트 및 언어",
      "roles": {
        "admin": "관리자",
        "manager": "매니저",
        "translator": "번역가"
      },
      "statuses": {
        "pending": "보류 중",
        "accepted": "수락됨",
        "declined": "거부됨"
      }
    },
    "errors": {
      "role": "역할을 선택해야 합니다",
      "domains": "선택한 역할에 대해 최소 1개의 웹사이트를 선택해야 합니다",
      "languages": "선택한 웹사이트에 대해 최소 1개의 언어를 선택해야 합니다"
    },
    "inviteSent": "초대장이 성공적으로 전송되었습니다"
  },
  "pagination": {
    "showing": "{{total}}개 결과 중 {{limit}}개 표시",
    "showing_only_count": "{{limit}}개 결과 표시"
  },
  "payments_method": {
    "header": "결제 수단",
    "table": {
      "title": "결제 수단 목록",
      "description": "계정에 연결된 결제 수단",
      "default": "기본값",
      "action_edit_remove": "편집 또는 제거",
      "action_remove": "제거",
      "action_default": "기본값으로 설정",
      "action_fallback": "대체값으로 설정",
      "expires": "만료",
      "add_new_card": "결제 수단 추가",
      "action_fallback_remove": "대체값에서 제거",
      "fallback": "대체값",
      "action_edit": "편집",
      "action_delete": "삭제",
      "action_default_remove": "기본값 해제",
      "domain_count@@one": "{{count}}개 도메인에서 사용",
      "domain_count@@other": "{{count}}개 도메인에서 사용됨"
    },
    "paypal_bind": {
      "button": "PayPal 계정 연결",
      "button_load": "연결 중...",
      "disconnected": "연결되지 않음",
      "success": "PayPal 계정이 연결되었습니다. 다음 청구서에서 $5가 차감됩니다!",
      "success_no_promo": "PayPal 계정이 연결되었습니다",
      "error": "오류가 발생했습니다",
      "success_header": "성공"
    },
    "card_add": {
      "header": "새 카드 추가",
      "success": "새 카드가 Linguise에 연결되었습니다!",
      "terms": "카드 정보를 제공함으로써 귀하는 Linguise의 서비스 약관에 따라 향후 결제를 위해 카드에 요금을 부여하는 것을 허용합니다."
    },
    "card_detail": {
      "header": "카드 정보",
      "delete": {
        "error": "활성 구독이 있으므로 이 결제 수단을 삭제할 수 없습니다!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "이 결제 수단의 구독",
        "header_domain": "도메인",
        "header_plan": "요금제",
        "header_status": "상태",
        "header_actions": "작업",
        "cancelling": "취소 예정: {{0}}",
        "next_payment": "다음 결제일: {{0}}",
        "action_renew": "갱신",
        "no_subs_header": "표시할 구독 없음",
        "no_subs_desc": "이 카드에 구독이 만들어지면 모든 정보가 여기에 표시됩니다",
        "action_manage": "관리"
      },
      "status": {
        "active": "활성",
        "canceled": "취소됨",
        "incomplete": "미결제",
        "incomplete_expired": "미결제(만료됨)",
        "missing": "오류",
        "past_due": "연체됨",
        "trialing": "체험 기간",
        "unpaid": "미결제"
      }
    },
    "delete_confirm_body": "이 결제 수단을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다!",
    "delete_confirm_header": "결제 수단을 삭제하시겠습니까?",
    "card_edit": {
      "header": "카드 편집",
      "billing_header": "청구 정보",
      "address_error": "주소는 필수입니다!",
      "card_number": "카드 번호",
      "card_expiry": "만료일",
      "expiry_error_month": "잘못된 월이 제공되었습니다.",
      "expiry_error_year": "잘못된 연도가 제공되었습니다.",
      "expiry_error_expired": "카드의 만료 연도가 지났습니다.",
      "card_header": "카드 정보",
      "expiry_error_empty": "이 필드는 필수입니다!"
    }
  },
  "plans": {
    "per": "당",
    "wordsTranslated": "번역된 단어",
    "current": "현재",
    "archived": "보관됨",
    "day": "일",
    "week": "주",
    "month": "월",
    "year": "년",
    "activate": "활성화",
    "cancel": "취소",
    "change": "변경",
    "upgrade": "업그레이드",
    "downgrade": "다운그레이드",
    "resume": "재개",
    "notEnoughWords": "단어가 충분하지 않습니다.",
    "yearIntervalOnly": "연간 요금제에서 마이그레이션할 수 없습니다.",
    "subsCanceled": "진행 중인 다른 구독 취소가 있습니다.",
    "wordsUnlimited": "무제한 단어",
    "tabs": {
      "day": "일일 가격",
      "week": "주간 가격",
      "month": "월간 가격",
      "year": "연간 가격",
      "sub_texts": {
        "day": "매일 고정 된 가격",
        "week": "매주 고정 된 가격",
        "month": "매달 고정 된 가격",
        "year": "한 달 무료, 매년 한 번 청구"
      }
    },
    "details": {
      "new_languages": "언제든지 새 언어 추가 가능",
      "one_month_trial": "새 웹사이트마다 한 달 무료 체험",
      "multi_content_indexed": "100% 다국어 콘텐츠 인덱싱",
      "translate_new_content": "새 콘텐츠 즉시 번역",
      "free_installation": "무료 설치 및 셋업",
      "compared_monthly_plan": "월간 요금제 대비 한 달 무료",
      "risk_free_recurring": "반복 결제 실패 시 위험 없음",
      "unlimited_languages": "무제한 언어 & 페이지뷰",
      "high_server_resources": "높은 서버 리소스",
      "billed": {
        "day": "일별 청구",
        "week": "주별 청구",
        "month": "월별 청구",
        "year": "연별 청구"
      },
      "request_max_size": "최대 {{0}} 요청 크기"
    },
    "frequent_question": {
      "title": "자주 묻는 질문",
      "questions": {
        "trial": {
          "question": "새 웹사이트 도메인에서도 무료 체험을 이용할 수 있나요?",
          "answer": "네, 계정에 추가하는 모든 새 웹사이트 도메인에 대해 30일 무료 체험을 제공합니다. 새 웹사이트에서 번역 서비스를 완전히 테스트할 수 있습니다."
        },
        "seo": {
          "question": "SEO가 개선되는 데 얼마나 걸리나요?",
          "answer": "콘텐츠와 다언어 콘텐츠가 완전히 인덱싱되고 높은 순위를 얻으려면 시간이 필요합니다. 사이트의 트래픽과 규모에 따라 3~6주 정도 소요됩니다."
        },
        "quota": {
          "question": "전문가 번역도 할당량에 포함되나요?",
          "answer": "아니요, 단어 수 제한은 자동 기계 번역에만 적용됩니다. 번역가는 자동 번역을 무제한으로 수동 수정할 수 있습니다."
        }
      }
    },
    "best_offer": "최상의 제안",
    "period": {
      "days@@one": "일",
      "days@@other": "{{count}}일",
      "hours@@one": "시간",
      "hours@@other": "{{count}}시간",
      "minutes@@one": "분",
      "minutes@@other": "{{count}}분",
      "seconds@@one": "초",
      "seconds@@other": "{{count}}초"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{period}}당 {{words}} 단어"
  },
  "profile": {
    "welcome": "환영합니다!",
    "account": "내 계정",
    "subscriptions": "구독 관리",
    "logout": "로그아웃"
  },
  "register": {
    "errors": {
      "password": "최소 8자, 모든 문자 가능"
    }
  },
  "route": {
    "dashboard": "대시보드",
    "rules": "규칙",
    "translations": "번역",
    "search_translations": "검색어",
    "urls_translations": "URL 번역",
    "links": "미디어 및 외부 링크",
    "online_editor": "라이브 에디터",
    "settings": "설정",
    "domain": {
      "finish": "설정",
      "preconfig": "설정"
    },
    "home": "홈",
    "domain_list": "도메인 목록",
    "members": "멤버",
    "invoices": "인보이스",
    "billing": "청록 정보",
    "language_display": "언어 깃발 표시",
    "payment_methods": "결제 수단",
    "ai_translation": "AI 번역",
    "ai_translation_settings": "설정",
    "ai_translation_pricing": "가격"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "무시할 텍스트",
        "add": "추가",
        "title": "무시할 텍스트",
        "description": "하나 이상의 무시할 텍스트를 추가하세요.",
        "ignore_case": "대소문자 무시"
      },
      "html_content": {
        "title": "HTML 콘텐츠에 적용",
        "description": "규칙을 전체 콘텐츠에 적용하거나 특정 CSS 선택자를 지정하세요.",
        "all_page": "전체 페이지",
        "css_selector": "CSS 선택자",
        "label": "CSS 선택자",
        "placeholder": "적용할 선택자",
        "add": "새로 추가"
      },
      "apply_to_urls": {
        "title": "URL에 적용",
        "description": "규칙을 적용할 특정 URL 선택",
        "all_urls": "모든 URL",
        "selected_urls": "선택한 URL",
        "label": "적용할 URL",
        "placeholder": "적용할 URL",
        "original_url": "원본 URL",
        "translated_url": "번역된 URL",
        "wildcard": "와일드카드",
        "regex": "정규 표현식",
        "add": "새로 추가",
        "expression": "표현식 유형"
      },
      "apply_urls": {
        "title_exclude": "URL에서 제외",
        "title_replace": "URL에서 교체",
        "title_description": "URL 번역에도 이 규칙 적용"
      },
      "apply_languages": {
        "title": "언어에 적용",
        "description": "규칙을 적용할 특정 언어 선택",
        "all_languages": "모든 언어",
        "selected_languages": "선택한 언어",
        "placeholder": "언어 선택...",
        "feedback": "언어를 선택해야 합니다"
      },
      "name": {
        "title": "제목",
        "description": "규칙에 제목을 지정하세요",
        "placeholder": "규칙 이름"
      },
      "type": {
        "title": "유형",
        "description": "추가할 규칙 유형 선택",
        "text_ignore": "텍스트 무시",
        "text_replace": "텍스트 교체",
        "content_exclusion": "콘텐츠 제외",
        "url_exclusion": "URL로 제외",
        "ignore_inline": "인라인 무시",
        "full_description": {
          "text_ignore": "번역하지 않을 텍스트를 추가하세요. 제품명, 브랜드명, 기술 요소 등입니다.",
          "text_replace": "텍스트 교체는 문맥을 무시한 번역 시 원하는 번역으로 교체할 수 있습니다.",
          "content_exclusion": "콘텐츠 제외는 페이지의 일부 콘텐츠를 번역하지 않게 합니다.\n페이지 전체를 번역에서 완전히 제외하려면(다중 언어 URL도 없고 번역 콘텐츠도 없음) \"URL로 제외\" 유형을 사용하세요.",
          "url_exclusion": "페이지 번역 제외는 번역하지 않을 페이지를 설정합니다.",
          "ignore_inline": "일부 콘텐츠를 인라인으로 번역하지 않고 각 태그를 개별적으로 번역합니다."
        }
      },
      "text_replace": {
        "title": "교체할 텍스트",
        "description": "특정 번역으로 텍스트를 교체하세요. 페이지 전체에서 텍스트를 언어별로 교체합니다.",
        "text_to_replace": "교체할 텍스트",
        "ignore_case": "대소문무시",
        "text_type": "번역에서 교체",
        "text_type_original": "원본",
        "text_type_translation": "번역",
        "keep_case": "대소문 유지 시도",
        "add": "새로 추가"
      },
      "content_exclusion": {
        "title": "콘텐츠 제외",
        "description": "번역되지 않을 CSS 선택자 하나 이상 선택",
        "label": "CSS 선택자",
        "placeholder": "적용할 선택자",
        "add": "새로 추가"
      },
      "multilingual_url": {
        "title": "다중 언어 URL 사용",
        "description": "예로 설정하면 URL은 번역되지 않지만 페이지는 번역된 콘텐츠로 다중 언어를 유지합니다.",
        "live_example_title": "실시간 예시",
        "live_example_description": "소스 URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "생성된 URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "생성된 URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "규칙을 정적 콘텐츠, 동적 콘텐츠 또는 둘 다에 적용",
        "title": "콘텐츠에 적용",
        "all": "모든 콘텐츠",
        "static": "정적 콘텐츠",
        "dynamic": "동적 콘텐츠"
      },
      "force_apply_urls": {
        "title_description": "모든 URL 번역에 이 규칙을 강제 적용, 기존 번역 포함!",
        "title_replace": "URL에서 강제 교체",
        "title_exclude": "URL에서 강제 제외",
        "warning": "경고",
        "warning_part1": "\"예\"로 설정하면 웹사이트 URL 번역이 손상될 수 있습니다.",
        "warning_part2": "일시적 또는 영구적으로 404 페이지가 생성될 수 있으므로, 결과를 이해하는 경우에만 계속하세요.",
        "warning_replacement_original": "추가 경고: URL에 영향을 줄 수 있는 원본 콘텐츠를 교체하려고 합니다. Linguise가 원본 URL을 정확히 찾지 못해 번역이 실패할 수 있습니다."
      }
    },
    "main": {
      "parent": "규칙",
      "edit": "규칙 편집",
      "add": "새 규칙"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "콘텐츠와 URL에서 \"{{text_ignore}}\"이(가) 무시됩니다",
      "preview_single": "콘텐츠에서 \"{{text_ignore}}\"이(가) 무시됩니다",
      "preview_more_with_url": "콘텐츠에서 \"{{text_ignore}}\" 및 {{count}}개가 더 무시됩니다",
      "preview_more": "콘텐츠에서 \"{{text_ignore}}\" 및 {{count}}개가 더 무시됩니다",
      "other_parameters": "이 규칙에 다른 매개변수가 설정되어 있습니다. 자세한 정보는 편집 버튼을 클릭하세요"
    },
    "text_replace": {
      "preview_single_with_url": "콘텐츠와 URL에서 \"{{original}}\"이(가) \"{{replacement}}\"으로 교체됩니다",
      "preview_single": "콘텐츠에서 \"{{original}}\"이(가) \"{{replacement}}\"으로 교체됩니다",
      "preview_more_with_url": "콘텐츠와 URL에서 \"{{original}}\"이(가) \"{{replacement}}\"으로 교체, 그리고 {{nb}}개 더",
      "preview_more": "콘텐츠에서 \"{{original}}\"이(가) \"{{replacement}}\"으로 교체, 그리고 {{nb}}개 더",
      "other_parameters": "이 규칙에 다른 매개변수가 설정되어 있습니다. 자세한 정보는 편집 버튼을 클릭하세요"
    },
    "content_exclusion": {
      "selectors": "번역에서 제외된 {{nb}}개 CSS 선택자",
      "other_parameters": "이 규칙에 다른 매개변수가 설정되어 있습니다. 자세한 정보는 편집 버튼을 클릭하세요"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}}개 URL이 번역에서 제외되었지만 다중 언어 접두사는 유지됩니다",
      "some": "{{nb}}개 URL이 완전히 번역에서 제외되었습니다",
      "all_multilingual": "모든 URL이 번역에서 제외되었지만 다중 언어 접두사는 유지됩니다",
      "all": "모든 URL이 완전히 번역에서 제외되었습니다",
      "other_parameters": "이 규칙에 다른 매개변수가 설정되어 있습니다. 자세한 정보는 편집 버튼을 클릭하세요"
    },
    "ignore_inline": {
      "elements": "페이지의 모든 인라인 콘텐츠가 블록 콘텐츠로 번역됩니다",
      "all_elements": "페이지의 일부 인라인 콘텐츠가 블록 콘텐츠로 번역됩니다",
      "other_parameters": "이 규칙에 대한 다른 매개변수가 설정되어 있습니다. 자세한 내용을 보려면 편집 버튼을 클릭하세요."
    },
    "title": "규칙 관리",
    "description": "웹사이트 전체의 번역 콘텐츠 제외 및 교체를 관리합니다",
    "add": "새 규칙 추가",
    "table": {
      "title": "제목",
      "no_data": "아직 규칙이 없습니다",
      "type": "유형",
      "preview": "규칙 미리보기",
      "action": "작업",
      "delete_confirm": "규칙 삭제를 확인해 주세요",
      "types": {
        "text_ignore": "텍스트 무시",
        "text_replace": "텍스트 교체",
        "content_exclusion": "콘텐츠 제외",
        "url_exclusion": "URL 제외",
        "ignore_inline": "인라인 무시",
        "unknown": "알 수 없는 규칙"
      }
    },
    "apply_on_content": {
      "static": "이 규칙은 정적 콘텐츠에만 적용됩니다.",
      "dynamic": "이 규칙은 동적 콘텐츠에만 적용됩니다."
    }
  },
  "search_translations": {
    "title": "검색어 관리",
    "description": "검색 양식을 통해 사용된 모든 웹사이트 번역을 나열합니다(번역된 언어에서 도메인 기준 언어로)",
    "filter_languages": "언어로 필터링...",
    "filter_original": "원본 언어로 텍스트 필터링",
    "filter_translation": "번역된 텍스트로 필터링",
    "table": {
      "original": "원본",
      "language": "언어",
      "translation": "번역"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "구독 실패!",
      "title": "구독 실패!",
      "subtitle": "구독 처리 중에 오류가 발생했습니다.",
      "home": "홈으로 돌아가기",
      "generic": "Linguise 측에서 알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요!"
    },
    "success": {
      "home": "도메인 번역 관리",
      "message": "최고의 번경 experience를 제공하기 위해 최선을 다하고 있습니다. 전문가 팀이 질문이나 지원이 필요할 때 언제든지 도와드립니다. 시작하려면 아래 버튼을 클릭하세요.",
      "subtitle": "Linguise 번역 서비스를 선택해 주셔서 감사합니다",
      "title": "구독이 활성화되었습니다!",
      "tab_title": "구독해 주셔서 감사합니다!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "구독이 활성화되었습니다!",
      "title": "구독이 활성화되었습니다!",
      "subtitle": "Linguise 번역 서비스를 선택해 주셔서 감사합니다",
      "message": "'최고의 번역 experience를 제공하기 위해 최선을 다하고 있습니다. 전문가 팀이 질문이나 지원이 필요할 때 언제든지 도와드립니다. 시작하려면 아래 버튼을 클릭하세요.",
      "home": "도메인 번역 관리"
    },
    "edit": {
      "title": "구독 관리"
    },
    "list": {
      "title": "구독 목록",
      "description": "도메인 구독 목록"
    },
    "table": {
      "domain": "도메인",
      "plan": "요금제",
      "status": "상태",
      "card": "카드",
      "usage": "사용량",
      "actions": "작업",
      "payment_method": "결제 수단"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} 단어",
      "paidOffered": "{{words_used}} / {{words_allowed}} 단어\n(포함된 {{free_words}} 개 무료 단어)"
    },
    "popup": {
      "dueToday": "오늘 총 결제 금액",
      "nextPeriod": "{{date}}부터 시작"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "계정 선택"
    }
  },
  "translation": {
    "main": {
      "parent": "번역",
      "edit": "번역 수정"
    },
    "form": {
      "original": {
        "title": "{{language}}로 원본"
      },
      "is_inline": "이 번역은 인라인 콘텐츠에서 이루어졌습니다.",
      "inline_editor": {
        "count_warning": "인라인 영역 수가 원본과 일치하지 않습니다({{current}}/{{expected}}).",
        "restore_original": "원본 텍스트 복원",
        "insert_placeholder": "자리표시자 삽입",
        "drag": "드래그하여 인라인 영역 순서 변경",
        "area": "인라인 영역 {{index}}",
        "restore": "누락된 인라인 영역 복원"
      },
      "translation": {
        "title": "{{language}}로 번역",
        "description": "덮어쓰고 싶은 번역"
      }
    },
    "copy": {
      "title": "수동 번역으로 복사",
      "label": "수동으로 복사"
    },
    "level": {
      "base": {
        "title": "기본 번역",
        "subtitle": "자동 · Linguise Cloud 번역",
        "empty": "이 텍스트에는 기본 번역이 없습니다.",
        "overridden": "선택한 내용은 저장되었지만, AI 번역 설정에서 “수동 번역 및 선택한 번역 덮어쓰기”가 예로 설정되어 있어 대신 최신 AI 강화 번역이 표시됩니다. 선택한 내용을 사용하려면 해당 설정을 끄세요."
      },
      "not_generated": "생성되지 않음",
      "none": "아직 없음",
      "ai": {
        "title": "AI 강화 번역",
        "subtitle": "자동 · Linguise AI",
        "empty_title": "이 텍스트에 대해 아직 생성되지 않음",
        "empty_description": "Linguise AI는 페이지와 웹사이트의 맥락을 활용해 더 자연스러운 번역을 제공합니다. 여기에 표시하려면:",
        "empty_step_1": "AI 번역 › 설정으로 이동하여 AI 번역 활성화를 “규칙만”, “라이브 에디터만” 또는 “규칙 및 라이브 에디터”로 설정하세요.",
        "empty_step_2": "이 페이지에 일치하는 규칙으로 적용하거나, 라이브 에디터에서 페이지별로 활성화하세요.",
        "empty_step_3": "생성되면 AI 강화 번역이 여기에 표시됩니다. AI 크레딧이 사용됩니다.",
        "open_settings": "AI 번역 설정 열기",
        "open_editor": "라이브 에디터 열기",
        "overrides_selection": "선택한 내용은 저장되었지만, AI 번역 설정에서 “수동 번역 및 선택한 번역 덮어쓰기”가 예로 설정되어 있어 대신 이 AI 강화 번역이 표시됩니다. 선택한 내용을 사용하려면 해당 설정을 끄세요.",
        "overrides_version": "선택한 버전은 저장되었지만, AI 번역 설정에서 “수동 번역 및 선택한 번역 덮어쓰기”가 예로 설정되어 있어 대신 최신 AI 강화 버전이 표시됩니다. 선택한 버전을 사용하려면 해당 설정을 끄세요."
      },
      "manual": {
        "title": "수동 번역",
        "subtitle": "직접 작성 · 자동 번역보다 우선 적용됨",
        "empty": "비어 있음",
        "saved_but_overridden": "내 선택으로 저장되었지만, AI 번역 설정에서 “수동 번역 덮어쓰기”가 예로 설정되어 있어 자동으로 표시되지 않습니다. 해당 설정을 끄기 전까지는 AI 강화 번역이 우선합니다.",
        "ignored": "AI 번역 설정에서 “수동 번역 덮어쓰기”가 예로 설정되어 있어 자동으로 표시되지 않습니다. 이 텍스트에 사용하려면 선택하세요.",
        "label": "내 번역",
        "placeholder": "직접 번역을 입력하세요...",
        "last_updated": "마지막 수정: {{date}}",
        "save_hint": "수동 번역을 저장하면 바로 적용됩니다.",
        "delete": "수동 번역 삭제",
        "delete_confirm": "수동 번역 삭제를 확인해 주세요"
      }
    },
    "history": {
      "title": "AI 강화 버전",
      "subtitle": "라이브 에디터에서 재생성한 모든 버전이 보관됩니다",
      "unknown_model": "알 수 없는 모델",
      "current": "현재",
      "restore": "이 버전 복원",
      "restore_note": "복원하면 해당 버전이 현재 AI 강화 번역이 됩니다. 삭제되는 항목은 없습니다.",
      "version_of": "버전 {{current}} / {{total}}",
      "hide": "기록 숨기기 ({{total}})",
      "show": "기록 보기 ({{total}})"
    },
    "choose": {
      "title": "{{language}} 번역 · 방문자에게 표시할 번역 선택",
      "current": "현재 웹사이트에 표시 중:",
      "priority": "기본 우선순위: 수동 › AI 강화 › 기본. 선택은 이 번역에만 저장됩니다.",
      "reset": "기본 우선순위로 재설정",
      "reset_title": "이 텍스트에 대한 선택을 지우고 기본 우선순위를 다시 사용합니다",
      "resetting": "재설정 중..."
    }
  },
  "translations": {
    "title": "번역 관리",
    "description": "웹사이트의 모든 번역을 나열하고 수정합니다. 시각적 번역을 위해 라이브 에디터를 사용하세요.",
    "filter_languages": "언어로 필터링...",
    "filter_original": "원본 언어로 텍스트 필터링",
    "filter_translation": "번역된 텍스트로 필터링",
    "table": {
      "original": "원본",
      "language": "언어",
      "action": "작업",
      "base": "기본",
      "ai": "AI 강화",
      "manual": "수동"
    },
    "filter_exact": "정확히 일치",
    "badge": {
      "active": "적용 중",
      "overrides_manual": "수동 덮어씀"
    },
    "cell": {
      "none": "없음",
      "not_generated": "생성되지 않음",
      "ignored": "무시됨 – AI 규칙 우선"
    },
    "tabs": {
      "all": "전체",
      "manual": "수동 있음",
      "ai": "AI 강화 있음",
      "base": "기본만"
    },
    "levels_hint": "각 텍스트에는 최대 3개의 단계가 있으며, 적용 중으로 표시된 것이 방문자에게 표시됩니다."
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "URL 번역 수정"
    },
    "form": {
      "original": {
        "title": "{{language}}로 원본"
      },
      "translation": {
        "title": "{{language}}로 URL 번역",
        "description": "덮어쓰고 싶은 URL",
        "placeholder": "Url 번역 재정의",
        "invalid_full": "잘못된 형식으로 변경하려고 합니다. URL 번역의 슬러그/경로명만 변경해야 합니다.",
        "invalid": "잘못된 URL/경로가 제공되었습니다"
      }
    }
  },
  "urls": {
    "title": "URL 관리",
    "description": "웹사이트의 모든 번역된 URL 콘텐츠를 나열하고 수정합니다(고급, 404 오류 주의)",
    "filter_languages": "언어로 필터링...",
    "filter_original": "원본 언어로 텍스트 필터링",
    "filter_translation": "번역된 텍스트로 필터링",
    "table": {
      "original": "원본",
      "language": "언어",
      "url": "번역된 URL",
      "action": "작업",
      "edited": "원본이 수정되었습니다"
    }
  }
}
